module.exports = __webpack_public_path__ + "3ee1f4018b2a75b01b6a5800d02bb1ca.png";